@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/transcript-subtitles-panel/clipping-studio-transcript-subtitles-panel.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.transcript-panel__body::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.transcript-panel__body::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.transcript-panel__body::-webkit-scrollbar-corner {
  background: transparent;
}
.transcript-panel__body::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.transcript-panel__body::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.transcript-panel__body::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.transcript-panel__body::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.transcript-panel__body::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
:host.style-panel-open {
  overflow: visible;
}
.transcript-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  font-family: "Open Sans", sans-serif;
  position: relative;
}
.transcript-panel--style-panel-open {
  overflow: visible;
}
.transcript-panel__tabs {
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
  flex-shrink: 0;
}
.transcript-panel__tab {
  flex: 1;
  padding: 12px 8px;
  font-size: 13px;
  font-weight: 700;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;
}
.transcript-panel__tab--active {
  border-bottom-color: rgb(45, 187, 252);
  color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.06);
}
.transcript-panel__body {
  flex: 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.transcript-panel__tag-block {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.transcript-panel .filter-option-header {
  font-size: 12px;
  font-family: "OpenSans";
  color: #7d8fa1;
  margin-bottom: 5px;
  display: block;
}
.transcript-panel__tag-list {
  padding-left: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}
.transcript-panel__tag-list li {
  margin: 7px 8px 6px 0;
}
.transcript-panel__source-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px;
  background: rgb(255, 255, 255);
  border: 1px solid #dde3e7;
  border-radius: 6px;
  width: 100%;
  box-sizing: border-box;
}
.transcript-panel__source-card--selected {
  border-color: #40c4ff;
  color: #232f3a;
}
.transcript-panel__source-card--selected .transcript-panel__source-label {
  color: #232f3a;
}
.transcript-panel__source-label {
  flex: 1;
  font-size: 12px;
  font-family:
    "OpenSans",
    "Open Sans",
    sans-serif;
  color: #879baf;
}
.transcript-panel__regenerate-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 6px;
  height: 22px;
  min-width: 48px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  background-color: transparent;
  color: rgba(0, 0, 0, 0.54);
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
  flex-shrink: 0;
}
.transcript-panel__regenerate-btn:focus {
  outline: none;
  box-shadow: none;
}
.transcript-panel__regenerate-btn:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.04);
}
.transcript-panel__regenerate-btn:disabled {
  opacity: 0.7;
  cursor: default;
}
.transcript-panel__regenerate-spinner {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid rgba(0, 0, 0, 0.14);
  border-top-color: rgb(45, 187, 252);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
  margin-right: 6px;
}
.transcript-panel__pill {
  font-size: 12px;
  font-family:
    "OpenSans",
    "Open Sans",
    sans-serif;
  padding: 5px 12px;
  height: 28px;
  box-sizing: border-box;
  border: 1px solid #dde3e7;
  border-radius: 6px;
  background: rgb(255, 255, 255);
  color: #879baf;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.transcript-panel__pill:hover {
  border-color: #40c4ff;
  color: #232f3a;
}
.transcript-panel__pill--active {
  border-color: #40c4ff;
  color: #232f3a;
}
.transcript-panel__search-wrap {
  width: 100%;
  min-width: 0;
}
.transcript-panel__search-wrap ichannel-input {
  width: 100%;
}
.transcript-panel__search-wrap ::ng-deep ichannel-input input {
  border-radius: 6px;
}
.transcript-panel__search-wrap ::ng-deep ichannel-input > div.rowInput,
.transcript-panel__search-wrap ::ng-deep ichannel-input > div {
  margin-bottom: 0;
}
.transcript-panel__blocks {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.transcript-panel__empty {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.35);
  margin: 0;
  padding: 24px 0;
  text-align: center;
}
.transcript-panel__loading {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.35);
  margin: 0;
  padding: 16px 0;
}
.transcript-panel__error {
  font-size: 13px;
  color: #c62828;
  margin: 0;
  padding: 16px 0;
}
.transcript-panel__actions-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.transcript-panel__btn {
  font-size: 11px;
  font-weight: 700;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
}
.transcript-panel__btn--primary {
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  border: none;
}
.transcript-panel__btn--primary:hover {
  opacity: 0.9;
}
.transcript-panel__btn--outline {
  background: rgb(255, 255, 255);
  color: rgb(45, 187, 252);
  border: 1px solid rgb(45, 187, 252);
}
.transcript-panel__btn--outline:hover {
  background: rgba(45, 187, 252, 0.08);
}
.transcript-panel__btn--secondary {
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  border: 1px solid rgba(0, 0, 0, 0.14);
}
.transcript-panel__btn--secondary:hover {
  background: rgb(235, 240, 244);
}
.transcript-panel__file-label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  padding: 8px 12px;
  border-radius: 6px;
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  border: 1px solid rgba(0, 0, 0, 0.14);
  cursor: pointer;
}
.transcript-panel__file-label:hover {
  background: rgb(235, 240, 244);
}
.transcript-panel__file-input {
  display: none;
}
.transcript-panel__export-wrap {
  position: relative;
  width: 100%;
}
.transcript-panel__export-wrap > .transcript-panel__btn {
  width: 100%;
  box-sizing: border-box;
}
.transcript-panel__export-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  margin-top: 4px;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 0;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
  z-index: 1100;
  min-width: 120px;
}
.transcript-panel__export-option {
  display: block;
  width: 100%;
  padding: 8px 12px;
  font-size: 12px;
  text-align: left;
  border: none;
  background: none;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
}
.transcript-panel__export-option:hover {
  background: rgb(235, 240, 244);
}
.transcript-panel__lang-mgmt {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.transcript-panel__lang-mgmt-header {
  padding: 0 4px;
  margin-bottom: 6px;
}
.transcript-panel__lang-mgmt-title {
  font-size: 10px;
  font-weight: 800;
  color: rgba(0, 0, 0, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.transcript-panel__lang-mgmt-table-wrap {
  background: rgb(255, 255, 255);
  border-radius: 0;
}
.transcript-panel__lang-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-family: "Open Sans", sans-serif;
}
.transcript-panel__lang-row {
  background: rgb(255, 255, 255);
}
.transcript-panel__lang-row--active {
  background: rgb(255, 255, 255);
}
.transcript-panel__lang-cell {
  padding: 10px 12px;
  vertical-align: middle;
  border: none;
}
.transcript-panel__lang-cell--info {
  width: auto;
  min-width: 0;
}
.transcript-panel__lang-cell--btn {
  width: 148px;
  min-width: 148px;
  padding-right: 20px;
  text-align: right;
}
.transcript-panel__lang-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  width: 100%;
}
.transcript-panel__lang-trash-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  min-width: 26px;
  height: 26px;
  flex-shrink: 0;
}
.transcript-panel__lang-row-name {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
}
.transcript-panel__lang-row-sublabel {
  display: block;
  font-size: 7px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.35);
  text-transform: uppercase;
  margin-top: 2px;
}
.transcript-panel__lang-btn {
  font-size: 9px;
  font-weight: 800;
  padding: 4px 8px;
  width: 100px;
  min-width: 100px;
  height: 26px;
  box-sizing: border-box;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.transcript-panel__lang-btn--active {
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  border: none;
}
.transcript-panel__lang-btn--active:hover {
  opacity: 0.9;
}
.transcript-panel__lang-btn--switch {
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  border: 1px solid rgba(0, 0, 0, 0.14);
}
.transcript-panel__lang-btn--switch:hover {
  background: rgb(235, 240, 244);
}
.transcript-panel__lang-btn--generate {
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  border: 1px solid rgba(0, 0, 0, 0.14);
}
.transcript-panel__lang-btn--generate:hover {
  background: rgb(235, 240, 244);
}
.transcript-panel__lang-btn--trash {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  min-width: 26px;
  height: 26px;
  padding: 0;
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  border: 1px solid rgba(0, 0, 0, 0.14);
  text-transform: none;
}
.transcript-panel__lang-btn--trash:hover {
  background: rgb(235, 240, 244);
}
.transcript-panel__lang-btn--trash:active {
  background: rgb(235, 240, 244);
}
.transcript-panel__lang-trash-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  line-height: 0;
}
.transcript-panel__lang-trash-icon ::ng-deep svg {
  width: 14px;
  height: 14px;
  display: block;
}
.transcript-panel__style-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.transcript-panel__style-label-row {
  padding: 0 4px;
}
.transcript-panel__toolbar {
  display: flex;
  align-items: stretch;
  gap: 8px;
}
.transcript-panel__toolbar .transcript-panel__search-wrap {
  flex: 1;
  min-width: 0;
  max-width: calc(100% - 5px);
}
.transcript-panel__btn--style {
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  border: 1px solid rgba(0, 0, 0, 0.14);
}
.transcript-panel__btn--style:hover {
  background: rgb(235, 240, 244);
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=clipping-studio-transcript-subtitles-panel.component.css.map */
